import { createAction } from '@reduxjs/toolkit';

/**
 * "Signal" action: the intent the page dispatches for the saga to act on. Kept out
 * of the slice's reducers: it triggers a side effect (the POST), not a state
 * transition (the saga owns the resulting transitions).
 *
 * The token rides in the payload rather than living in the store, exactly as in
 * `reset-password`: the URL is its single source of truth, so no spent token lingers
 * in the store after the page is left.
 */
export const confirmRequested = createAction<{ token: string }>(
  'confirmEmailChange/confirmRequested',
);
